import type { FormInstance } from 'antd';
import type { TFunction } from 'i18next';

/**
 * Structurally satisfied by both the raw antd message instance and the
 * `useFeedback()` wrapper (utils/feedback.ts) — callers should prefer the
 * wrapper so the error inherits the 8s error duration.
 */
type MessageApi = { error: (content: string) => unknown };

export function applySupplierSaveError(
  error: any,
  form: FormInstance,
  t: TFunction,
  message: MessageApi,
  fallbackMessage: string
): void {
  const responseData = error?.response?.data;

  if (responseData?.code === 'DUPLICATE_SUPPLIER_TAX_ID') {
    form.setFields([
      {
        name: 'taxId',
        errors: [
          t('suppliers:messages.taxIdExists', {
            name: responseData.existingSupplierName || t('suppliers:messages.existingSupplierFallback')
          })
        ]
      }
    ]);
  } else {
    // Backend prose is English and not part of the user-facing contract.
    // Field-specific server rejections get a dedicated map above; every other
    // failure remains actionable without exposing implementation wording.
    message.error(t('suppliers:messages.saveFailedValidation') || fallbackMessage);
  }
}
